import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { LoginoneComponent } from './loginone/loginone.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { LockScreenComponent } from './lockscreen/lockscreen.component';
import { SubscribesComponent } from './subscribes/subscribes.component';
import { UnderMaintanceComponent } from './under-maintance/under-maintance.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ComingsoonV2Component } from './coming-soonV2/coming-soonV2.component';
import { MaintenanceV2Component } from './maintenanceV2/maintenanceV2.component';
import { SessionRoutingModule } from './session.routing';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AboutComponent } from './about/about.component';
import { TherapiesComponent } from './therapies/therapies.component';
import { TariffComponent } from './tariff/tariff.component';
import { HomeComponent } from './home/home.component';
import { FacilitiesComponent } from './facilities/facilities.component';
import { BookingComponent } from './booking/booking.component';
import { ContactusComponent } from './contactus/contactus.component';
import { GalleryComponent } from './gallery/gallery.component';
import { DincharyaComponent } from './dincharya/dincharya.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CustomNgxDateTimeModule } from 'app/shared/ngx-date-format.module';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { BookingLoginComponent } from './booking-login/booking-login.component';
import { DonateComponent } from './donate/donate.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { OnlineyogaComponent } from './onlineyoga/onlineyoga.component';

@NgModule({
   schemas: [CUSTOM_ELEMENTS_SCHEMA],
   imports: [
      CommonModule,
      FormsModule,
      TranslateModule,
      ReactiveFormsModule,
      SlickCarouselModule,
      NgxMatDatetimePickerModule,
      MatDatepickerModule,
      NgxMatNativeDateModule,
      NgbModule,
      NgxPaginationModule,
      Ng2SearchPipeModule,
      NgxMatTimepickerModule,
      MatNativeDateModule,
      MatFormFieldModule,
      MatInputModule,
      MatIconModule,
      MatAutocompleteModule,
      CustomNgxDateTimeModule,
      ToastrModule.forRoot(),
      // RouterModule.forChild(),
      SessionRoutingModule,

   ],
   declarations: [
      LoginoneComponent,
      RegisterComponent,
      ForgotPasswordComponent,
      ComingSoonComponent,
      LockScreenComponent,
      SubscribesComponent,
      UnderMaintanceComponent,
      NotFoundComponent,
      ComingsoonV2Component,
      MaintenanceV2Component,
      AboutComponent,
      TherapiesComponent,
      TariffComponent,
      HomeComponent,
      FacilitiesComponent,
      DincharyaComponent,
      BookingComponent,
      ContactusComponent,
      GalleryComponent,
      ChangePasswordComponent,
      BookingLoginComponent,
      DonateComponent,
      PaymentHistoryComponent,
      PaymentDetailsComponent,
      OnlineyogaComponent
   ], exports: [  // This is required so other modules can use AboutComponent
      SessionRoutingModule
   ]
})

export class SessionDemoModule { }
